import api from "@/api/v1-jwt/config/api";

const setAccessToken = async ({
  publicToken,
  userId,
  firstName,
  lastName,
  businessName,
  accountNickname,
  accountType,
  metadata,
  nameOnAccount = "",
  defaultPaymentMethod = false,
}) => {
  try {
    const apiUrl = `/platform/payment_methods/plaid/set_access_token`;

    const payload = {
      public_token: publicToken,
      cognito_id: userId,
      first_name: firstName,
      last_name: lastName,
      account_type: accountType,
      business_name: businessName,
      payment_method_nickname: accountNickname,
      payment_method_default: defaultPaymentMethod,
      metadata: metadata,
    };
    if (nameOnAccount !== "") {
      payload.name_on_account = nameOnAccount;
    }

    const { data } = await api.post(apiUrl, payload);

    return data?.data;
  } catch (err) {
    console.error("Error fetching access token:", err);
    if (err.response) {
      console.error("Server responded with:", err.response.data);
    }
  }
};

export default setAccessToken;
